import { soFormInitialValue } from 'src/vars'

export const SET_VALUE = (state, [key, value]) => {
  state[key] = value
}

export const RESET_FORM = (state) => {
  state.form = { ...soFormInitialValue }
  state.paymentMethodPrevValue = null
  state.revertPaymentMethodPrevValue = false
}

export const SET_FORM = (state, [key, value]) => {
  state.form[key] = value
}
